import { render, staticRenderFns } from "./IssueProfile.vue?vue&type=template&id=2aa83a0f&"
import script from "./IssueProfile.vue?vue&type=script&lang=js&"
export * from "./IssueProfile.vue?vue&type=script&lang=js&"
import style0 from "./IssueProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports